export default {
      id: "circleAdd-usage",
      viewBox: "0 0 24 24",
      url: "assets/" + "sprite.svg#circleAdd-usage",
      toString: function () {
        return this.url;
      }
    }